import { make } from 'vuex-pathify';

import UsersAPI from '../api/users.js';

const state = {
	user: {
		avatar_path: '',
		avatar_url: '',
		entity: {},
		login_status: false,
		permissions: [],
		playlists: [],
		signature: '',
		user_name: '',
		user_role: [],
		uuid: ''
	},
	users: [],
	userLoadStatus: 0,
	userEditStatus: 0,
	usersLoadStatus: 0
};

const mutations = {
	...make.mutations(state)
};

const actions = {
	...make.actions(state),
	getUser({ commit }) {
		commit('SET_USER_LOAD_STATUS', 1);

		return UsersAPI.getUserAPI()
			.then(function (response) {
				if (!response.data.signature) {
					response.data.signature = '';
				}
				commit('SET_USER', response.data);
				commit('SET_USER_LOAD_STATUS', 2);
			})
			.catch(function () {
				commit('SET_USER', []);
				commit('SET_USER_LOAD_STATUS', 3);
			});
	},
	setUser({ commit }, payload) {
		commit('SET_USER_EDIT_STATUS', 1);

		return UsersAPI.putUserAPI(payload)
			.then(function () {
				// commit('SET_USER', response.data);
				commit('SET_USER_EDIT_STATUS', 2);
			})
			.catch(function () {
				commit('SET_USER_EDIT_STATUS', 3);
			});
	}
};

const getters = {
	...make.getters(state)
	// substr(state) {
	// 	return function(start = 0) {
	// 		return state.string.substr(start);
	// 	};
	// }
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
// export const users = {
// 	state: {
// 		user: {},
// 		users: [],
// 		userLoadStatus: 0,
// 		userEditStatus: 0,
// 		usersLoadStatus: 0
// 	},

// 	actions: {},

// 	mutations,

// 	getters: {}
// };
